module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Dial-numbers-f703a36af870e0a410ac2bdb19f17786.svg";